import { render, staticRenderFns } from "./QueryCloseModal.vue?vue&type=template&id=3673dd88&"
import script from "./QueryCloseModal.vue?vue&type=script&lang=js&"
export * from "./QueryCloseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports